import {SPEED_FORMATS} from '../../constants/common';
import {Actions} from './actions';
import {AppAction, AppState} from './types';

const fetchStateFromLocalstorage = () => {
  const storedSpeedFormat = window.localStorage.getItem('speedFormat') as
    | (typeof SPEED_FORMATS)[number]
    | null;
  return {
    companyId: +(window.localStorage.getItem('companyId') || 0) || null,
    ...(storedSpeedFormat && SPEED_FORMATS.includes(storedSpeedFormat)
      ? {speedFormat: storedSpeedFormat}
      : {}),
  };
};

export const getAppInitialState: () => AppState = () => ({
  me: null,
  activeDraggableModal: null,
  myConfigurations: null,
  lastEventIds: {
    connect: null,
    ams: null,
    belt: null,
    hazard_ai: null,
    shaft_clearance: null,
  },
  muteSounds: false,
  printTheme: false,
  ...fetchStateFromLocalstorage(),
  activedDashboard: null,
  inSubmittingInSavingDashboard: false,
  speedFormat: SPEED_FORMATS[0],
});

const appReducers = (state?: AppState, action?: AppAction) => {
  state = state ?? getAppInitialState();
  switch (action?.type) {
    case Actions.SetApp:
      return {...state, ...action.data};

    default:
      return state;
  }
};

export default appReducers;
